import { createStore } from "redux";
// import myLogger from "./middlewares/myLogger";
import productsReducer from "./products/productsReducer";

const store = createStore(productsReducer);

export default store;
